import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalAction } from 'Src/feature/modal/ModalAction';
import { TextModal } from 'Src/feature/modal/TextModal';

const sectionId = 'ClearCheckModal';

interface ClearCheckModalProps {
  open: boolean;
  onClose: () => void;
  onClearCheck: () => void;
}

const ClearCheckModal: FC<ClearCheckModalProps> = ({ open, onClose, onClearCheck }) => {
  const { t } = useTranslation();

  return (
    <TextModal
      data-testid={sectionId}
      open={open}
      onBackDropClick={onClose}
      title={t('check.labels.clearCheck.title')}
      textContent={t('check.labels.clearCheck.prompt')}
      actions={(
        <>
          <ModalAction
            data-testid={`${sectionId}-cancel-btn`}
            label={t('labels.cancel')}
            color="secondary"
            onClick={onClose}
          />
          <ModalAction
            data-testid={`${sectionId}-clear-check-btn`}
            label={t('check.labels.clearCheck.action')}
            color="primary"
            onClick={onClearCheck}
          />
        </>
      )}
    />
  );
};

export { ClearCheckModal };
